import { formatPnlOneDecimal } from './pnlFormatting';

interface HomeSummaryLike {
  total_points?: number | null;
  points_balance?: number | null;
}

interface BuildHomeLeaderValueTextArgs {
  leaderTraderCode: string | null;
  leaderTotalPnl: number | null;
  currentTraderCode: string | null;
  currentTotalPnl: number | null;
  compact?: boolean;
  labels?: {
    empty?: string;
  };
}

export function resolveHomeSummaryTotalPnl(
  summary?: HomeSummaryLike | null,
  fallbackTotalPnl?: number | null,
) {
  if (typeof summary?.total_points === 'number') {
    return summary.total_points;
  }

  if (typeof fallbackTotalPnl === 'number') {
    return fallbackTotalPnl;
  }

  return null;
}

export function formatHomePnlValue(value: number | null) {
  if (value == null) {
    return '—';
  }

  return formatPnlOneDecimal(value);
}

export function buildHomeLeaderValueText({
  leaderTraderCode,
  leaderTotalPnl,
  labels,
}: BuildHomeLeaderValueTextArgs) {
  if (!leaderTraderCode || leaderTotalPnl == null) {
    return labels?.empty ?? 'Be the first to trade';
  }

  return `${leaderTraderCode} ${formatPnlOneDecimal(leaderTotalPnl)}`;
}
